module.exports = __webpack_public_path__ + "img/search-empty.22885ab5.png";